import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiTextArea {
    constructor() {

    }

    addTextAreaText() {
    }

    createTextArea() {
    }

    formatTextAreaText() {
    }

    lockTextArea() {
    }

    setTextAreaColor() {
    }

    setTextAreaFont() {
    }

    setTextAreaTabs() {
    }

    setTextAreaText() {
    }

    textAreaChar() {
    }

    textAreaCursor() {
    }

    textAreaLen() {
    }

    textAreaLine() {
    }

    textAreaLineLen() {
    }

    textAreaSelLen() {
    }

    textAreaText() {
    }

    unlockTextArea() {
    }
}
